import { generateClient } from "aws-amplify/api";
import { list_tickets } from '@/graphql/queries'
import { mapTicket } from './ticketHelpers'

export default {
  data() {
    return {
      ticketsList: [],
    }
  },
  methods: {
    async fetchTickets() {
      try {
        const client = generateClient();
        const response = await client.graphql({
          query: list_tickets,
          variables: {
            input: {
              limit: 200
            }
          }
        })

        let responseData = response.data.list_tickets
        if (typeof responseData === "string") {
          responseData = JSON.parse(responseData)
        }

        if (responseData.status == "SUCCESS") {
          const rows = Array.isArray(responseData.data) ? responseData.data : []
          this.ticketsList = rows
            .map(mapTicket)
            .filter((ticket) => ticket.statusRaw !== "DEACTIVE" && ticket.ticketId)
        } else {
          this.ticketsList = []
        }
      } catch (error) {
        console.error("Error fetching tickets:", error);
        this.ticketsList = [];
        throw error;
      }
    },
  },
};
